var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from "react";
import * as UnlinkedApplicationForm from "../../../components/UnlinkedApplicationForm";
import { Address, Button, parseGooglePlacesAddress, } from "@savvyinsure/react-ui";
import { validateNoPoBox, validateUnlinkedApplicantAddress, } from "../../../features/unlinked-application/validateUnlinkedApplicantAddress";
import AppBody from "../../../components/AppBody";
import Header from "../../../components/Header";
import { PHASE } from "../../../routeConfig";
import { Transition } from "@headlessui/react";
import { completedPage } from "../../../lib/Avo";
import { saveHomeowners } from "../../../features/unlinked-application/unlinkedApplicationSlice";
import { usaStates } from "typed-usa-states/dist/states";
import useAppDispatch from "../../../hooks/useAppDispatch";
import useAppSelector from "../../../hooks/useAppSelector";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { useHomePremiumNextRoute } from "./premium";
import useIsFlagOn from "../../../features/feature-flags/hooks/useIsFlagOn";
var nextRoute = PHASE.UNLINKED_APPLICATION_HOMEOWNERS_PREMIUM;
export default function UnlinkedApplicationHomeownersPropertyAddress() {
    var _this = this;
    var _a;
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics; }).commonAnalyticsProperties;
    var history = useHistory();
    var _b = useAppSelector(function (state) { return state.unlinkedApplication; }), policyHolder = _b.policyHolder, homeowners = _b.homeowners;
    var dispatch = useAppDispatch();
    var _c = useForm({
        mode: "all",
        shouldUseNativeValidation: false,
        defaultValues: {
            address1: homeowners.address1 || policyHolder.address1,
            address2: homeowners.address2 || policyHolder.address2,
            city: homeowners.city || policyHolder.city,
            state: homeowners.state || policyHolder.state,
            zip: homeowners.zip || policyHolder.zip,
        },
    }), register = _c.register, handleSubmit = _c.handleSubmit, _d = _c.formState, errors = _d.errors, isValid = _d.isValid, setValue = _c.setValue, watch = _c.watch;
    var isPremiumEnabled = useIsFlagOn("unlinkedApplication_premiumEnabled_frontend");
    var homePremiumNextRoute = useHomePremiumNextRoute();
    var address1Input = register("address1", {
        required: true,
        validate: {
            validateIsNotPoBox: function (value) {
                return validateNoPoBox(value) ||
                    "Please enter the address where your car is parked overnight. A PO Box is not allowed.";
            },
        },
    });
    var address2Input = register("address2");
    var cityInput = register("city", { required: true });
    var zipInput = register("zip", {
        required: true,
        minLength: 5,
        validate: {
            isValidPattern: function (val) {
                return /^([0-9]{5})(?:-([0-9]{4}))?$/.test(val) ||
                    "Please enter a valid US zipcode";
            },
            isNotZeroes: function (val) {
                return val !== "00000" || "Please enter a valid US zipcode";
            },
        },
    });
    var _e = watch([
        "address1",
        "address2",
        "city",
        "state",
        "zip",
    ]), address1 = _e[0], address2 = _e[1], city = _e[2], state = _e[3], zip = _e[4];
    var stateValue = state;
    var footerErrors = Object.values(errors).filter(function (error) { return error.type !== "validateIsNotPoBox"; });
    var submitHandler = handleSubmit(function (formData) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(saveHomeowners(formData));
            completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: "Continue", optionSelected: "Continue" }));
            history.push(isPremiumEnabled ? nextRoute : homePremiumNextRoute);
            return [2 /*return*/];
        });
    }); });
    React.useEffect(function () {
        register("state", {
            required: true,
            minLength: 2,
            maxLength: 2,
            validate: {
                validString: function (value) {
                    return (value.length === 2 && /^[a-zA-Z]+$/.test(value)) ||
                        "Please enter your state in an abbreviated format.\n Example: CA, NY, TX";
                },
                validState: function (value) {
                    return usaStates.some(function (state) { return state.abbreviation.toUpperCase() === value.toUpperCase(); }) || "Please enter a valid state abbreviation";
                },
            },
        });
    }, [register]);
    function handleOnCloseHeader() {
        var propertyAddressData = { address1: address1, address2: address2, city: city, state: state, zip: zip };
        var propertyAddressDataIsValid = validateUnlinkedApplicantAddress(propertyAddressData);
        if (propertyAddressDataIsValid) {
            dispatch(saveHomeowners(propertyAddressData));
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, { onClose: handleOnCloseHeader, showDropShadow: true },
            React.createElement(UnlinkedApplicationForm.Progress, null)),
        React.createElement(AppBody, { as: "form", onSubmit: submitHandler, action: "#" },
            React.createElement(UnlinkedApplicationForm.ScrollingContainer, null,
                React.createElement("div", { className: "mb-8 flex-none pt-4" },
                    React.createElement(UnlinkedApplicationForm.Header, null, "What's the address for the property you would like insured?")),
                React.createElement("div", { className: "flex grow flex-col space-y-4" },
                    React.createElement(Address, { streetAddress1: __assign(__assign({}, address1Input), { label: "Street Address", "aria-invalid": Boolean(errors === null || errors === void 0 ? void 0 : errors.address1), errorMessage: (_a = errors === null || errors === void 0 ? void 0 : errors.address1) === null || _a === void 0 ? void 0 : _a.message }), streetAddress2: __assign(__assign({}, address2Input), { label: "Apt/Suite #" }), city: __assign(__assign({}, cityInput), { label: "City", "aria-invalid": Boolean(errors === null || errors === void 0 ? void 0 : errors.city), id: "city" }), state: {
                            value: stateValue
                                ? { label: stateValue, value: stateValue }
                                : undefined,
                            "aria-invalid": Boolean(errors === null || errors === void 0 ? void 0 : errors.state),
                            placeholder: "",
                            onChange: function (selected) {
                                setValue("state", selected.value, { shouldValidate: true });
                            },
                        }, zipCode: __assign(__assign({}, zipInput), { "aria-invalid": Boolean(errors === null || errors === void 0 ? void 0 : errors.zip), label: "Zip", id: "zip" }), googlePlacesApiKey: process.env.GOOGLE_AUTOCOMPLETE_API_KEY, onPlaceSelected: function (place) {
                            if (!place)
                                return;
                            var nextAddress = parseGooglePlacesAddress(place);
                            if (!nextAddress)
                                return;
                            var address1 = "".concat(nextAddress.street_number, " ").concat(nextAddress.route);
                            if (nextAddress) {
                                setValue("address1", address1, { shouldValidate: true });
                                setValue("city", nextAddress.sublocality || nextAddress.locality, { shouldValidate: true });
                                setValue("state", nextAddress.administrative_area_level_1, {
                                    shouldValidate: true,
                                });
                                setValue("zip", nextAddress.postal_code, {
                                    shouldValidate: true,
                                });
                                dispatch(saveHomeowners({
                                    address1: address1,
                                    city: nextAddress.sublocality || nextAddress.locality,
                                    state: nextAddress.administrative_area_level_1,
                                    zip: nextAddress.postal_code,
                                }));
                            }
                        } }),
                    React.createElement("div", { className: "mt-4" },
                        React.createElement(Button, { disabled: !isValid }, "Continue"),
                        React.createElement(Transition, { show: !isValid, enter: "transition duration-500", enterFrom: "opacity-0", enterTo: "opacity-100", className: "mt-4 text-center text-xs font-bold leading-4 text-red" }, footerErrors.map(function (value, index) {
                            return value.message ? (React.createElement("div", { dangerouslySetInnerHTML: { __html: value.message }, key: index })) : null;
                        }))))))));
}
